export const TABLE_HEADING_TYPE = Symbol('heading');
